import { MissingAnswerMessageContainer } from "./components";
import Checkbox from "../../../components/icons/Checkbox";
import { IconSize } from "../../../components/theme";
import {
  QuestionOptionContainer,
  StyledOptionContainer,
  QuestionOptionsListContainer,
  StyledErrorMessage,
} from "./components";
import EmptyCircle from "../../../components/icons/EmptyCircle";
import { QuestionWithRelations } from "../../../../../api/src/types";
import { ParagraphSmall } from "../../../components/typography/Paragraph";

interface ReadOnlyRadioCheckboxProps {
  question: QuestionWithRelations;
  missingAnswerMessage: string;
}

const ReadOnlyRadioCheckbox: React.FC<ReadOnlyRadioCheckboxProps> = ({
  question,
  missingAnswerMessage,
}) => {
  const selectedOptions = question.answers[0]?.answerQuestionOptions.map(
    (option) => option.questionOptionId,
  );
  if (!selectedOptions || selectedOptions.length === 0) {
    return (
      <MissingAnswerMessageContainer>
        <StyledErrorMessage>{missingAnswerMessage}</StyledErrorMessage>
      </MissingAnswerMessageContainer>
    );
  }
  return (
    <QuestionOptionsListContainer data-testid="read-only-radio-checkbox">
      {question.questionOptions.map((option) => {
        return (
          <QuestionOptionContainer key={option.id}>
            <StyledOptionContainer
              isChecked={selectedOptions.includes(option.id)}
            >
              {selectedOptions.includes(option.id) ? (
                <Checkbox isChecked={true} size={IconSize.M} />
              ) : (
                <EmptyCircle />
              )}
              <ParagraphSmall fontWeight={300} textAlign="left">
                <span dangerouslySetInnerHTML={{ __html: option.value }} />
              </ParagraphSmall>
            </StyledOptionContainer>
          </QuestionOptionContainer>
        );
      })}
    </QuestionOptionsListContainer>
  );
};

export default ReadOnlyRadioCheckbox;
